import FaresCarouselBackgroundImageContainerMobile from '../../../../components/containers/FaresCarouselBackgroundImageContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadFareProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fares-carousel-background-image--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: FaresCarouselBackgroundImageContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
